import cs from 'classnames';
import React, { HTMLAttributeAnchorTarget } from 'react';
import s from './style.module.scss';

export interface INewsItem {
  id: string;
  title: string;
  desc: any;
  logo: string;
  imageUrl: string;
  link?: string;
  linkTarget?: HTMLAttributeAnchorTarget;
}

interface IProps {
  data: INewsItem;
}

export const NewsItem = ({ data }: IProps): JSX.Element => {
  return (
    <div
      id={data.id}
      className={cs(s.menu_item, { [`${s.menu_item_disabled}`]: !data.link })}
    >
      <a href={data.link} target={data.linkTarget}>
        <div className={s.menu_item_content}>
          <p className={s.logo}>{data.logo}</p>
          <img className={s.img} src={data.imageUrl} />
          <p className={s.title}>{data.title}</p>
          {typeof data.desc === 'string' ? (
            <p
              className={s.desc}
              dangerouslySetInnerHTML={{ __html: data.desc }}
            />
          ) : (
            <div className={s.desc}>{data.desc}</div>
          )}
        </div>
      </a>
    </div>
  );
};
